let _defaults;
export function defaultFormInstanceDeps() {
    if (!_defaults) {
        const { buildFluidFormClient } = require("../../fluidForm.client");
        const { ChatbotService: ChatbotServiceClass } = require("./FluidChat.service");
        const { parseError } = require("./errorUtils");
        _defaults = {
            buildClient: buildFluidFormClient,
            buildChatbotService: (client, dispatcher, formKey, submissionId, chatPath) => new ChatbotServiceClass(client, dispatcher, formKey, submissionId, chatPath),
            parseError,
        };
    }
    return _defaults;
}
